var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBillingOverview = function SvgBillingOverview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "billing_overview_svg2__a",
    x1: -10.21,
    x2: 139.19,
    y1: 207.6,
    y2: 14.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__c",
    x1: -62.59,
    x2: 86.82,
    y1: 167.12,
    y2: -26.22
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__d",
    x1: -31.94,
    x2: 117.47,
    y1: 190.81,
    y2: -2.54
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__e",
    x1: -34.51,
    x2: 114.89,
    y1: 188.82,
    y2: -4.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__f",
    x1: -20.47,
    x2: 128.93,
    y1: 199.67,
    y2: 6.32
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__g",
    x1: -2.6,
    x2: 146.8,
    y1: 213.47,
    y2: 20.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__h",
    x1: 24.22,
    x2: 173.62,
    y1: 234.2,
    y2: 40.86
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__i",
    x1: 3.51,
    x2: 152.91,
    y1: 218.2,
    y2: 24.85
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__j",
    x1: 43.75,
    x2: 193.16,
    y1: 249.3,
    y2: 55.95
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__k",
    x1: -62.59,
    x2: 86.82,
    y1: 167.12,
    y2: -26.22
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__l",
    x1: -31.94,
    x2: 117.47,
    y1: 190.81,
    y2: -2.54
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__m",
    x1: -34.51,
    x2: 114.89,
    y1: 188.82,
    y2: -4.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__n",
    x1: -20.47,
    x2: 128.93,
    y1: 199.67,
    y2: 6.32
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__o",
    x1: -2.6,
    x2: 146.8,
    y1: 213.47,
    y2: 20.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__p",
    x1: 24.22,
    x2: 173.62,
    y1: 234.2,
    y2: 40.86
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__q",
    x1: 3.51,
    x2: 152.91,
    y1: 218.2,
    y2: 24.85
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#billing_overview_svg2__a",
    id: "billing_overview_svg2__r",
    x1: 43.75,
    x2: 193.16,
    y1: 249.3,
    y2: 55.95
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M143.41 149.14c-1.73 0-3.12 1.4-3.12 3.12v35.08c0 2.83-2.3 5.13-5.13 5.13H10.65c-2.83 0-5.13-2.3-5.13-5.13V12.74c0-2.83 2.3-5.13 5.13-5.13h94.34v25.73c0 3.59 2.92 6.51 6.51 6.51h28.79v21.22c0 1.73 1.4 3.12 3.12 3.12s3.12-1.4 3.12-3.12V36.73c0-.65-.36-1.67-.99-2.27-.32-.3-35.01-32.01-35.32-32.28-.56-.51-1.47-.82-2.1-.82H10.65C4.37 1.37-.73 6.47-.73 12.74v174.6c0 6.27 5.1 11.38 11.38 11.38h124.51c6.27 0 11.38-5.1 11.38-11.38v-35.08c0-1.73-1.4-3.12-3.12-3.12ZM111.49 33.6c-.14 0-.26-.12-.26-.26V11.57c2.94 2.68 22.24 20.32 24.11 22.03h-23.86Z",
    style: {
      fill: "url(#billing_overview_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.91 30.63h54.78c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12H17.91c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12",
    style: {
      fill: "url(#billing_overview_svg2__c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.88 56.52c0-1.73-1.4-3.12-3.12-3.12H17.91c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h107.84c1.73 0 3.12-1.4 3.12-3.12Z",
    style: {
      fill: "url(#billing_overview_svg2__d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.69 82.41H17.91c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h54.78c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12",
    style: {
      fill: "url(#billing_overview_svg2__e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.91 117.67h54.78c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12H17.91c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12",
    style: {
      fill: "url(#billing_overview_svg2__f)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.92 140.44H17.91c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h67.01c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12",
    style: {
      fill: "url(#billing_overview_svg2__g)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.79 172.58c0 1.73 1.4 3.12 3.12 3.12h107.84c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12H17.91c-1.73 0-3.12 1.4-3.12 3.12",
    style: {
      fill: "url(#billing_overview_svg2__h)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.85 76.77c-13.96 2.97-23.35 15.02-24.04 28.15a3.13 3.13 0 0 0 2.96 3.29h.17c1.65 0 3.03-1.29 3.12-2.96.55-10.56 8.15-20.04 19.1-22.37a3.128 3.128 0 1 0-1.3-6.12Z",
    style: {
      fill: "url(#billing_overview_svg2__i)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194 146.15-6.08-4.84a3.13 3.13 0 0 0-4.39.5 3.12 3.12 0 0 0 .5 4.39l6.08 4.84a7.71 7.71 0 0 1 1.23 10.83c-2.68 3.36-7.51 3.86-10.83 1.23l-21.25-16.92 9.6-12.06 4.7 3.74c1.35 1.08 3.32.85 4.39-.5 1.08-1.35.85-3.32-.5-4.39l-7.14-5.69a3.125 3.125 0 0 0-4.39.5l-.37.47-5.75-4.58c7.73-17.84 2.67-38.44-12.7-50.65a42.96 42.96 0 0 0-35.81-8.31c-35.11 7.47-46.1 52.93-17.66 75.53 15.77 12.55 38.41 12.3 53.83-.24l5.34 4.25-.37.47a3.12 3.12 0 0 0 .5 4.39l23.7 18.87c6.01 4.78 14.79 3.84 19.61-2.22 4.81-6.03 3.81-14.8-2.22-19.61Zm-96.48-10.8c-24.37-19.37-14.79-58.17 15.09-64.53 11-2.39 22.21.44 30.65 7.13a36.515 36.515 0 0 1 7.11 49.86l-1.13 1.54c-16.42 17.77-37.59 17.25-51.72 6.01Zm57.94-3.91s.01-.03.02-.04c.48-.68.94-1.36 1.37-2.07l4.78 3.81-4.96 6.23-4.64-3.69c1.67-1.83 2.67-3.18 3.41-4.23Z",
    style: {
      fill: "url(#billing_overview_svg2__j)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.41 149.14c-1.73 0-3.12 1.4-3.12 3.12v35.08c0 2.83-2.3 5.13-5.13 5.13H10.65c-2.83 0-5.13-2.3-5.13-5.13V12.74c0-2.83 2.3-5.13 5.13-5.13h94.34v25.73c0 3.59 2.92 6.51 6.51 6.51h28.79v21.22c0 1.73 1.4 3.12 3.12 3.12s3.12-1.4 3.12-3.12V36.73c0-.65-.36-1.67-.99-2.27-.32-.3-35.01-32.01-35.32-32.28-.56-.51-1.47-.82-2.1-.82H10.65C4.37 1.37-.73 6.47-.73 12.74v174.6c0 6.27 5.1 11.38 11.38 11.38h124.51c6.27 0 11.38-5.1 11.38-11.38v-35.08c0-1.73-1.4-3.12-3.12-3.12ZM111.49 33.6c-.14 0-.26-.12-.26-.26V11.57c2.94 2.68 22.24 20.32 24.11 22.03h-23.86Z",
    style: {
      fill: "url(#billing_overview_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.91 30.63h54.78c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12H17.91c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12",
    style: {
      fill: "url(#billing_overview_svg2__k)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.88 56.52c0-1.73-1.4-3.12-3.12-3.12H17.91c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h107.84c1.73 0 3.12-1.4 3.12-3.12Z",
    style: {
      fill: "url(#billing_overview_svg2__l)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.69 82.41H17.91c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h54.78c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12",
    style: {
      fill: "url(#billing_overview_svg2__m)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.91 117.67h54.78c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12H17.91c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12",
    style: {
      fill: "url(#billing_overview_svg2__n)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.92 140.44H17.91c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h67.01c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12",
    style: {
      fill: "url(#billing_overview_svg2__o)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.79 172.58c0 1.73 1.4 3.12 3.12 3.12h107.84c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12H17.91c-1.73 0-3.12 1.4-3.12 3.12",
    style: {
      fill: "url(#billing_overview_svg2__p)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.85 76.77c-13.96 2.97-23.35 15.02-24.04 28.15a3.13 3.13 0 0 0 2.96 3.29h.17c1.65 0 3.03-1.29 3.12-2.96.55-10.56 8.15-20.04 19.1-22.37a3.128 3.128 0 1 0-1.3-6.12Z",
    style: {
      fill: "url(#billing_overview_svg2__q)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194 146.15-6.08-4.84a3.13 3.13 0 0 0-4.39.5 3.12 3.12 0 0 0 .5 4.39l6.08 4.84a7.71 7.71 0 0 1 1.23 10.83c-2.68 3.36-7.51 3.86-10.83 1.23l-21.25-16.92 9.6-12.06 4.7 3.74c1.35 1.08 3.32.85 4.39-.5 1.08-1.35.85-3.32-.5-4.39l-7.14-5.69a3.125 3.125 0 0 0-4.39.5l-.37.47-5.75-4.58c7.73-17.84 2.67-38.44-12.7-50.65a42.96 42.96 0 0 0-35.81-8.31c-35.11 7.47-46.1 52.93-17.66 75.53 15.77 12.55 38.41 12.3 53.83-.24l5.34 4.25-.37.47a3.12 3.12 0 0 0 .5 4.39l23.7 18.87c6.01 4.78 14.79 3.84 19.61-2.22 4.81-6.03 3.81-14.8-2.22-19.61Zm-96.48-10.8c-24.37-19.37-14.79-58.17 15.09-64.53 11-2.39 22.21.44 30.65 7.13a36.515 36.515 0 0 1 7.11 49.86l-1.13 1.54c-16.42 17.77-37.59 17.25-51.72 6.01Zm57.94-3.91s.01-.03.02-.04c.48-.68.94-1.36 1.37-2.07l4.78 3.81-4.96 6.23-4.64-3.69c1.67-1.83 2.67-3.18 3.41-4.23Z",
    style: {
      fill: "url(#billing_overview_svg2__r)",
      strokeWidth: 0
    }
  }));
};
export default SvgBillingOverview;